import React from 'react';
import Icon from '../icons/Icon';
import stylesheet from './EventLocation.module.scss';

const EventLocation = props => {
    const {event} = props,
        {location_name: name, location_address: address, location_city: city} = event;

    if (![name, address, city].join('').length) return null;

    return (
        <div className={stylesheet.EventLocation}>
            <Icon src="/img/globe.png" />
            <div>
                <div className={stylesheet.name}>{name}</div>
                <div className={stylesheet.address}>{address}</div>
                <div className={stylesheet.city}>{city}</div>
            </div>
        </div>
    );
};

export default EventLocation;
